import { fromPostgrest, guard, type Result } from '@/lib/result';
import { supabase } from '@/lib/supabase';

import { mapSlot, type AvailabilitySlot } from '../model/availability';

export const availabilityRepository = {
  async listByProvider(providerId: string): Promise<Result<readonly AvailabilitySlot[]>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('availability')
        .select('weekday, prayer_slot')
        .eq('provider_id', providerId);
      if (error) throw fromPostgrest(error);
      return ((data ?? []) as unknown[]).map(mapSlot);
    });
  },

  /**
   * Replaces the provider's entire availability. Delete-then-insert, scoped to
   * the caller's own rows (safe under RLS; self-correctable on partial failure).
   */
  async replaceAll(providerId: string, slots: readonly AvailabilitySlot[]): Promise<Result<void>> {
    return guard(async () => {
      const del = await supabase.from('availability').delete().eq('provider_id', providerId);
      if (del.error) throw fromPostgrest(del.error);
      if (slots.length === 0) return;
      const rows = slots.map((s) => ({
        provider_id: providerId,
        weekday: s.weekday,
        prayer_slot: s.prayer,
      }));
      const ins = await supabase.from('availability').insert(rows);
      if (ins.error) throw fromPostgrest(ins.error);
    });
  },
};
